import { inject, provideEnvironmentInitializer } from '@angular/core';
import { getModuleGroupByName } from '@softline/application';
import {
  provideSoftAppsModule,
  withSoftAppsModuleNavItem,
  withSoftAppsModuleRoutes,
  withSoftAppsModuleTranslation,
} from '@softapps/core';
import { default as de } from '../i18n/de.json';
import { default as en } from '../i18n/en.json';
import { aiAgentRoutes } from './ai-agent.routes';
import { provideAiAgentClientTools } from './ai-agent.tokens';
import {
  AiAgentModuleConfig,
  DEFAULT_AI_AGENT_CONFIG,
  SOFTLINE_CONFIG_AI_AGENT,
  SOFTLINE_MODULE_AI_AGENT,
  SOFTLINE_PERMISSION_AI_AGENT,
} from './ai-agent.shared';
import { AiAgentRepository } from './repositories/ai-agent.repository';
import { AiAgentChatService } from './services/ai-agent-chat.service';
import { AiAgentShellPanelService } from './services/ai-agent-shell-panel.service';
import { getCurrentContextTool } from './tools/get-current-context.tool';
import { listMasterdataEntitiesTool } from './tools/list-masterdata-entities.tool';
import { navigateToTool } from './tools/navigate-to.tool';
import { resolveMasterdataTool } from './tools/resolve-masterdata.tool';
import { suggestFollowupsTool } from './tools/suggest-followups.tool';

// Same group as ai-table-extractor — keeps the AI modules together.
const MODULE_GROUP_NAME = 'Workflow';

export const provideAiAgentModule = (config?: AiAgentModuleConfig) => {
  return [
    {
      provide: SOFTLINE_CONFIG_AI_AGENT,
      useValue: { ...DEFAULT_AI_AGENT_CONFIG, ...config },
    },
    // Root, not route-scoped: the shell renders panel components through
    // *ngComponentOutlet without an injector, so page and panel can only share
    // one thread when the conversation lives in the environment injector.
    AiAgentRepository,
    AiAgentChatService,
    provideEnvironmentInitializer(() => inject(AiAgentShellPanelService).register()),
    provideAiAgentClientTools(
      navigateToTool,
      getCurrentContextTool,
      listMasterdataEntitiesTool,
      resolveMasterdataTool,
      suggestFollowupsTool
    ),
    provideSoftAppsModule(
      {
        name: SOFTLINE_MODULE_AI_AGENT,
        title: '#AI_AGENT.TITLE',
        icon: 'fa-regular fa-robot',
        route: '/ai-agent',
        permission: SOFTLINE_PERMISSION_AI_AGENT,
        group: getModuleGroupByName(MODULE_GROUP_NAME),
      },
      withSoftAppsModuleRoutes({ app: aiAgentRoutes }),
      withSoftAppsModuleTranslation({ de, en }),
      withSoftAppsModuleNavItem([
        {
          name: 'ai-agent-chat',
          title: '#AI_AGENT.CHAT_PAGE_TITLE',
          icon: 'fa-regular fa-robot',
          routerLink: ['/ai-agent/chat'],
          entry: true,
        },
      ])
    ),
  ];
};
